exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcomeHeader{text-align:center!important;margin-bottom:21px}#welcomeHeader1{font-size:32px}#welcomeHeader2{font-size:24px}.welcomeHeaderContainer{text-align:center!important;margin-top:10%}.welcomeHeaderBtn{float:none}.character-image{width:80%;float:right}.adminPageTitle{color:#b4e166;font-size:30px;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/dashboard/homeDashboard.scss
// module id = 1294
// module chunks = 2